import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PhoneFrame } from './components/layout/PhoneFrame';
import { MainLayout } from './components/layout/MainLayout';
import { Splash } from './pages/Splash';
import { Welcome } from './pages/Welcome';
import { Onboarding } from './pages/Onboarding';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { OTP } from './pages/auth/OTP';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { ResetPassword } from './pages/auth/ResetPassword';
import { RoleSelect } from './pages/auth/RoleSelect';
import { Feed } from './pages/Feed';
import { Discover } from './pages/Discover';
import { Search } from './pages/Search';
import { SearchResults } from './pages/SearchResults';
import { UploadOptions } from './pages/upload/UploadOptions';
import { Record } from './pages/upload/Record';
import { Preview } from './pages/upload/Preview';
import { Caption } from './pages/upload/Caption';
import { Progress } from './pages/upload/Progress';
import { Success } from './pages/upload/Success';
import { Profile } from './pages/Profile';
import { EditProfile } from './pages/EditProfile';
import { Notifications } from './pages/Notifications';
import { Settings } from './pages/Settings';
import { SettingsPrivacy } from './pages/settings/Privacy';
import { SettingsNotifications } from './pages/settings/NotificationSettings';
import { SettingsSecurity } from './pages/settings/Security';
import { HashtagFeed } from './pages/HashtagFeed';
// Placeholder components for routes we haven't built yet
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="flex w-full h-full items-center justify-center text-softGray" data-id="element-0">
    {title}
  </div>;
export function App() {
  return <BrowserRouter data-id="element-1">
      <PhoneFrame data-id="element-2">
        <Routes data-id="element-3">
          {/* Entry Flow */}
          <Route path="/" element={<Splash data-id="element-5" />} data-id="element-4" />
          <Route path="/welcome" element={<Welcome data-id="element-7" />} data-id="element-6" />
          <Route path="/onboarding" element={<Onboarding data-id="element-9" />} data-id="element-8" />

          {/* Auth Flow */}
          <Route path="/auth/login" element={<Login data-id="element-11" />} data-id="element-10" />
          <Route path="/auth/register" element={<Register data-id="element-13" />} data-id="element-12" />
          <Route path="/auth/role" element={<RoleSelect data-id="element-15" />} data-id="element-14" />
          <Route path="/auth/otp" element={<OTP data-id="element-17" />} data-id="element-16" />
          <Route path="/auth/forgot" element={<ForgotPassword data-id="element-19" />} data-id="element-18" />
          <Route path="/auth/reset" element={<ResetPassword data-id="element-21" />} data-id="element-20" />

          {/* Main App with Bottom Nav */}
          <Route element={<MainLayout data-id="element-23" />} data-id="element-22">
            <Route path="/feed" element={<Feed data-id="element-25" />} data-id="element-24" />
            <Route path="/discover" element={<Discover data-id="element-27" />} data-id="element-26" />
            <Route path="/notifications" element={<Notifications data-id="element-29" />} data-id="element-28" />
            <Route path="/profile" element={<Profile data-id="element-31" />} data-id="element-30" />
          </Route>

          {/* Modals / Full Screen without Bottom Nav */}
          <Route path="/upload" element={<UploadOptions data-id="element-33" />} data-id="element-32" />
          <Route path="/upload/record" element={<Record data-id="element-35" />} data-id="element-34" />
          <Route path="/upload/preview" element={<Preview data-id="element-37" />} data-id="element-36" />
          <Route path="/upload/caption" element={<Caption data-id="element-39" />} data-id="element-38" />
          <Route path="/upload/progress" element={<Progress data-id="element-41" />} data-id="element-40" />
          <Route path="/upload/success" element={<Success data-id="element-43" />} data-id="element-42" />

          <Route path="/search" element={<Search data-id="element-45" />} data-id="element-44" />
          <Route path="/search/results" element={<SearchResults data-id="element-47" />} data-id="element-46" />

          <Route path="/profile/edit" element={<EditProfile data-id="element-49" />} data-id="element-48" />
          <Route path="/settings" element={<Settings data-id="element-51" />} data-id="element-50" />
          <Route path="/settings/privacy" element={<SettingsPrivacy data-id="element-53" />} data-id="element-52" />
          <Route path="/settings/notifications" element={<SettingsNotifications data-id="element-55" />} data-id="element-54" />
          <Route path="/settings/security" element={<SettingsSecurity data-id="element-57" />} data-id="element-56" />
          <Route path="/hashtag/:tag" element={<HashtagFeed data-id="element-59" />} data-id="element-58" />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-61" />} data-id="element-60" />
        </Routes>
      </PhoneFrame>
    </BrowserRouter>;
}